export default __webpack_public_path__ + "static/media/flip-vertical.26d07700.svg";